import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

interface Props {
  label: string;
}

export const InterestRate = ({ label }: Props) => {
  const formBag = useFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.InterestRate"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label={label}
        />
      )}
    />
  );
};
